<div class="jumbotron">
  <h1 class="display-4">Hola, Bienvenido!</h1>
  <p class="lead">Sistema de Control de Stock y Ventas.</p>
  <hr class="my-4" />
  <p>Opciones del Administrador.</p>
  <a class="btn btn-primary btn-lg" href="#" role="button">Ayuda</a>
</div>
